<div class="tablet:flex hidden items-center">
  <tui-hosted-dropdown
    data-test-id="openPreferences"
    [content]="settings"
    [(open)]="isSettingsMenuOpen"
    (openChange)="triggerOpenChange($event)"
  >
    <dev-portal-action-button
      class="text-day-text-icons-gray-500 dark:text-night-text-icons-gray-500 hover:oneinch-bg-hover-main-gray"
      icon="/assets/icons/settings-linear.svg#img"
    ></dev-portal-action-button>
  </tui-hosted-dropdown>
</div>

<dev-portal-action-button
  (click)="triggerOpenChange(true)"
  class="tablet:hidden text-day-text-icons-gray-500 dark:text-night-text-icons-gray-500 hover:oneinch-bg-hover-main-gray"
  icon="/assets/icons/settings-linear.svg#img"
  data-test-id="openPreferences"
></dev-portal-action-button>

<ng-template #settingsMobile>
  <div class="w-full transition-all duration-200" [@slideUpDown]>
    <ng-container *ngTemplateOutlet="settings; context: { isMobile: true }"></ng-container>
  </div>
</ng-template>

<ng-template #themeChoice>
  <ng-container>
    <dev-portal-modal-header
      leadingIcon="/assets/icons/arrow-left-simple.svg#img"
      (clickLeading)="backToSettings()"
      title="Mode"
      [trailingIcon]="null"
    ></dev-portal-modal-header>

    <div class="bg-day-bg-bg-main dark:bg-night-bg-bg-main flex flex-col pb-6 pt-2" [formGroup]="themeForm">
      <ng-template #themeItem let-theme="theme">
        <div
          [attr.data-test-id]="'selectTheme' + theme"
          class="hover:text-day-text-icons-main dark:hover:text-night-text-icons-main dark:hover:bg-night-bg-bg-2ry hover:bg-day-bg-bg-2ry flex cursor-pointer items-center justify-between gap-4 self-stretch p-4"
          (click)="toggleTheme(theme)"
        >
          <svg class="text-day-text-icons-gray-500 h-6 w-6">
            <use [attr.href]="'/assets/icons/' + theme.toLowerCase() + '-theme.svg#img'" />
          </svg>
          <span
            class="oneinch-text-medium-16 flex-1"
            [ngClass]="
              currentTheme() === theme
                ? 'text-day-text-icons-main dark:text-night-text-icons-main'
                : 'text-day-text-icons-gray-500 dark:text-night-text-icons-gray-500'
            "
          >
            {{ "navigation.settings.theme." + theme | transloco }}
          </span>

          <input type="radio" [value]="theme" formControlName="selectedTheme" />
        </div>
      </ng-template>

      <ng-container *ngTemplateOutlet="themeItem; context: { theme: 'onDark' }"></ng-container>
      <ng-container *ngTemplateOutlet="themeItem; context: { theme: 'onLight' }"></ng-container>
      <ng-container *ngTemplateOutlet="themeItem; context: { theme: 'onSystem' }"></ng-container>
    </div>
  </ng-container>
</ng-template>

<ng-template #settings let-isMobile="isMobile">
  <div
    data-test-id="globalPreferencesHeader"
    class="tablet:w-96"
    [ngClass]="isMobile ? 'tablet:hidden' : 'tablet:block hidden'"
  >
    @switch (settingsType) {
      @case ("language") {
        {{ "navigation.settings.language.title" | transloco }}
      }
      @case ("theme") {
        <ng-container *ngTemplateOutlet="themeChoice"></ng-container>
      }
      @default {
        <dev-portal-modal-header
          (clickTrailing)="triggerOpenChange(false)"
          titleAlignment="left"
          [title]="'navigation.preferences.title' | transloco"
          trailingIcon="/assets/icons/close.svg#img"
        ></dev-portal-modal-header>

        <div class="bg-day-bg-bg-main dark:bg-night-bg-bg-main tablet:flex-row tablet:p-2 flex flex-col gap-2 py-2">
          <div
            class="navigationItem tablet:bg-day-bg-bg-2ry tablet:dark:bg-night-bg-bg-2ry hover:bg-day-bg-bg-2ry hover:dark:bg-night-bg-bg-2ry tablet:grid-cols-[1fr,auto] tablet:grid-rows-[auto,auto,1fr] tablet:items-start tablet:gap-0 tablet:p-4 grid flex-1 cursor-pointer grid-cols-[auto,1fr,auto] items-center gap-x-4 rounded-xl px-4 py-3"
            (click)="settingsType = 'theme'"
            data-test-id="toggleTheme"
          >
            <svg class="text-day-text-icons-gray-500 dark:text-night-text-icons-gray-500 icon h-6 w-6">
              <use [attr.href]="themeIcon()" />
            </svg>
            <svg class="text-day-text-icons-gray-500 dark:text-night-text-icons-gray-500 arrow h-6 w-6">
              <use href="/assets/icons/arrow-right.svg#img" />
            </svg>
            <div class="oneinch-text-medium-16 headline tablet:pt-6">
              {{ "navigation.settings.theme." + currentTheme() | transloco }}
            </div>
            <div class="oneinch-text-regular-13 text-day-text-icons-gray-500 subline">
              {{ "navigation.settings.theme.label" | transloco }}
            </div>
          </div>
          <div
            class="navigationItem tablet:bg-day-bg-bg-2ry tablet:dark:bg-night-bg-bg-2ry hover:bg-day-bg-bg-2ry hover:dark:bg-night-bg-bg-2ry tablet:grid-cols-[1fr,auto] tablet:grid-rows-[auto,auto,1fr] tablet:items-start tablet:gap-0 tablet:p-4 grid flex-1 cursor-pointer grid-cols-[auto,1fr,auto] items-center gap-x-4 rounded-xl px-4 py-3"
          >
            <img class="text-day-text-icons-main icon h-6 w-6" src="/assets/language/en.png" />
            <!-- chosing other languages is currently deactivated -->
            <!-- <svg class="text-day-text-icons-gray-500 dark:text-night-text-icons-gray-500 arrow h-6 w-6">
            <use href="/assets/icons/arrow-right.svg#img" />
          </svg> -->
            <div class="oneinch-text-medium-16 headline tablet:pt-6">
              {{ "navigation.settings.languages.0" | transloco }}
            </div>
            <div class="oneinch-text-regular-13 text-day-text-icons-gray-500 subline">
              {{ "navigation.settings.language.label" | transloco }}
            </div>
          </div>
        </div>
      }
    }
  </div>
</ng-template>
